import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CLIENT_UPDATE_TAP_EVENT, consumeClientUpdateTap } from '../../lib/clientPush';

/**
 * Opens the delivery a client tapped an update for (`clientPush.js`):
 * one parked by a cold start, and any that arrives while the app runs.
 * Mounted once under the router; draws nothing.
 */
export default function ClientUpdateTaps() {
  const navigate = useNavigate();

  useEffect(() => {
    const parked = consumeClientUpdateTap();
    if (parked) navigate(parked);

    const onTap = (e) => {
      consumeClientUpdateTap();
      const link = e?.detail?.link;
      if (typeof link === 'string' && link.startsWith('/')) navigate(link);
    };
    window.addEventListener(CLIENT_UPDATE_TAP_EVENT, onTap);

    return () => window.removeEventListener(CLIENT_UPDATE_TAP_EVENT, onTap);
  }, [navigate]);

  return null;
}
